import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@resy/ui-kitchen';
import './AmexShopSmallTerms.scss';
import Chevron from '../../../images/amexrga/chevron-left.svg';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';

const AmexShopSmallTerms = (
  {
    termsActive,
    termsConfig: {
      subsections,
      title,
    },
    termsHeight,
    toggleTerms,
  }
) => (
  <section className="AmexShopSmallTerms">
    <div className="container">
      <div className="AmexShopSmallTerms__Terms">
        <h2
          id="terms"
          className={`AmexShopSmallTerms__Terms__title ${termsActive ? 'active' : ''}`}
        >
          <Button
            variant="no-style"
            type="button"
            id="AmexShopSmallTermsTitle"
            aria-controls="AmexShopSmallTermsContent"
            className="AmexShopSmallTerms__Terms__button"
            aria-expanded={termsActive}
            onClick={() => {
              toggleTerms('');
            }}
          >
            <Chevron className="AmexShopSmallTerms__Terms__icon" />
            {title}
          </Button>
        </h2>
        <div
          style={{ maxHeight: `${termsHeight}` }}
          aria-labelledby="AmexShopSmallTermsTitle"
          id="AmexShopSmallTermsContent"
          className="AmexShopSmallTerms__Terms__content"
          aria-hidden={!termsActive}
          tabIndex="-1"
        >
          <ol
            className="AmexShopSmallTerms__Terms__text"
          >
            {subsections.map((terms) => {
              const sanitizedTermsCopy = sanitizeString(terms?.copy);
              return (
                <li key={terms.id}>
                  <div className="AmexShopSmallTerms__anchorHolder">
                    <div id={terms.id} className="AmexShopSmallTerms__anchor" />
                  </div>
                  <h3>{terms.header}</h3>
                  <div
                    dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                      __html: sanitizedTermsCopy,
                    }}
                  />
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  </section>
);

AmexShopSmallTerms.propTypes = {
  termsActive: PropTypes.bool.isRequired,
  termsConfig: PropTypes.shape({
    hashList: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired,
    subsections: PropTypes.arrayOf(PropTypes.shape(
      {
        header: PropTypes.string,
        copy: PropTypes.string,
      }
    )).isRequired,
  }).isRequired,
  termsHeight: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  toggleTerms: PropTypes.func.isRequired,
};

export default AmexShopSmallTerms;
